import React, { Component } from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";

import "../../../styles/components/map/mapboxExtensions/Recent.scss";

class Recent extends Component {
  render() {
    return (
      <div id="recent">
        <div className="header">
          <p>
            <Translate value="map_recent" />
          </p>
        </div>
        <div className="recents">
          {this.props.recent.map((place, k) => {
            const split = place.split(",");
            const title = split.shift();
            const address = split.join(",");
            return (
              <div key={place + k}>
                <div
                  className="recent"
                  onClick={e => this.props.query(e, `${title},${address}`, this.props.country, this.props.keyTab)}
                >
                  <p className="title">{title}</p>
                  <p className="address">{address}</p>
                </div>
                {k + 1 !== this.props.recent.length && <hr className="splitter" />}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  country: state.account.accountData.country,
});

export default connect(mapStateToProps, null)(Recent);
